import type * as Highcharts from 'highcharts';
import type { NamedSolution } from '../../types';
import { compare_name_asc } from '../utils';
import { bestValueDataLabel, type ChartBuildOptions } from './bestValueLabel';

const kiloRounded = (value: number | undefined) => Math.round(((value as number) / 1000) * 100) / 100;

/** NPV of the CAPEX, OPEX and cleaning gains of each solution (stacked), with the NPV line; the best NPV is marked. */
export const buildFinancialComparisonOptions = (data: NamedSolution[], { forExport }: ChartBuildOptions = {}): Highcharts.Options => {
  const sorted = [...data].sort(compare_name_asc);
  const npv = sorted.map((item) => kiloRounded(item?.net_present_value));
  const maxNPV = Math.max(...npv);
  const best = bestValueDataLabel(forExport);

  return {
    chart: { type: 'column' },
    title: { text: 'Financial Comparison', align: 'left' },
    xAxis: { categories: sorted.map((item) => item.name) },
    yAxis: [{ title: { text: '(KUSD)' } }],
    tooltip: { headerFormat: '<b>{point.x}</b><br/>', pointFormat: '{series.name}: {point.y}' },
    credits: { enabled: false },
    plotOptions: { column: { stacking: 'normal', dataLabels: { enabled: true } } },
    series: [
      { type: 'column', name: 'NPV CAPEX (KUSD)', data: sorted.map((item) => kiloRounded(item?.capex?.total)) },
      { type: 'column', name: 'NPV OPEX (KUSD)', data: sorted.map((item) => kiloRounded(item?.opex?.total)) },
      { type: 'column', name: 'NPV Cleaning Gains (KUSD)', data: sorted.map((item) => kiloRounded(item?.cleaning_gains)) },
      {
        type: 'line',
        name: 'NPV (KUSD)',
        data: npv,
        dataLabels: {
          enabled: true,
          useHTML: best.useHTML,
          allowOverlap: true,
          formatter: function () {
            return this.point.y === maxNPV ? best.text : this.point.y;
          },
          style: { textAlign: 'center', color: '#000', fontSize: '24px', x: 0, y: -10 } as Highcharts.CSSObject,
        },
      },
    ],
  };
};
